<template>
  <div id="app_user">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app_user',
  components: {

  },
  created(){
    this.$commonJs.resetTenantId();
  },

  mounted() {

  },

}
</script>

<style lang="scss">
@import '@/styles/element.scss';
@import '@/styles/common.scss';
#app_user {
  min-width: 1675px;
  width: 100%;
  margin: auto;
}
</style>
